import { Wrench, Flame, Zap, Microwave, Utensils, Fan, Thermometer, Hammer, ArrowRight, PhoneCall } from 'lucide-react';

const services = [
    {
        icon: <Fan size={28} />, // Chimney implies airflow/exhaust
        title: "24 HOURS AMBULANCE SERVICES",
        desc: "We provide 24/7 best ambulance services with best facilities to our clients.These services are provided by our team of professionals in accordance.",
        path: "/chimney-repair-service"
    },
    {
        icon: <Utensils size={28} />, // Hob-specific icon
        title: "AC AMBULANCE SERVICES",
        desc: "Our Ambulance Services are provided to clients at budget-friendly market prices. These services are provided by our team of professionals in accordance. We also provide AC Ambulance Services to our clients.",
        path: "/hob-repair-service"
    },
    {
        icon: <Wrench size={28} />, // General tool for mechanical work
        title: "ACCIDENT CASE AMBULANCE SERVICES",
        desc: "We have a fleet of ambulances with the necessary facilities, like monitors ,ventilators and continuous oxygen supply in Royal Ambulance at any accident cases.",
        path: "/cooking-range-service"
    },
    {
        icon: <Flame size={28} />, // More appropriate for gas stove
        title: "Emergency Ambulance Services",
        desc: "We provide Cardiac ambulance services with best facilities to our clients. These services are provided by our team of professionals in accordance.",
        path: "/gas-stove-repair-service"
    },
    {
        icon: <Zap size={28} />, // Suits electric/induction cooktops
        title: "DEAD BODY FREEZER BOX ON HIRE",
        desc: "This freezer box is installed in home to keep the human remains inside it.",
        path: "/cook-repair-service"
    },
    {
        icon: <Microwave size={28} />,
        title: "ROAD AMBULANCE SERVICES",
        desc: "End-to-end gas appliance servicing including leak detection, regulator replacement, pipe maintenance, and compliance checks.",
        path: "/gas-service-repair-service"
    }
];



const HomeServices = () => {
    return (
        <section className="hob-services-section">
            <div className="hob-services-header">
                <h2 className="hob-services-heading">Our  Services</h2>
                <p className="hob-services-subtext">We keep your ambulance running like new with expert hands and trusted drivers.</p>
            </div>
            <div className="hob-services-grid">
                {services.map((service, idx) => (
                    <div className="hob-service-card" key={idx}>
                        <div className="hob-service-icon">{service.icon}</div>
                        <h3 className="hob-service-title">{service.title}</h3>
                        <p className="hob-service-desc">{service.desc}</p>
                        <div className="hob-service-actions">
                           {/* <span
                                className="hob-service-link"
                                onClick={() => window.location.href = service.path}
                                style={{ cursor: "pointer" }}
                            >
                                Learn More <ArrowRight size={14} />
                            </span>  */}
                            <span
                                className="hob-service-link"
                               onClick={() => (window.location.href = "tel:70390 34000")}
                                style={{ cursor: "pointer" }}
                            >
                               <PhoneCall size={14} />Call Now
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default HomeServices;
